import { render, staticRenderFns } from "./TeamAlignmentComponent.vue?vue&type=template&id=0c06b08d&scoped=true"
import script from "./TeamAlignmentComponent.vue?vue&type=script&lang=ts"
export * from "./TeamAlignmentComponent.vue?vue&type=script&lang=ts"
import style0 from "./TeamAlignmentComponent.vue?vue&type=style&index=0&id=0c06b08d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c06b08d",
  null
  
)

export default component.exports